import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import { useHistory } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import "../../assets/styles/local/WorkflowAutomation.css";
import AddIcon from "../../assets/icons/addicon.svg";
import formBuilder from "../../assets/icons/WorkflowAutomation/workflow_icon.png";
import WorkflowList from "./WorkflowList";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const WorkflowAutomationDashboard = () => {
  const history = useHistory();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-List").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [hover, setHover] = useState(false);

  return (
    <>
      {/* Header Section for path display */}
      <Header
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/settings");
              }}
            >
              {/* Settings */}
              {t("Settings")}
            </div>
            <p className="products-and-parts-sub-title workflow_header">
              {/* Workflow Automation */}
              {t("Workflow Automation")}
            </p>
          </div>
        }
      />

      {/* Dashboard Actions */}
      <div className="ps-4 pe-4">
        <Row>
          <Col xl={8} lg={8} md={6} sm={12}></Col>
          <Col xl={4} lg={4} md={6} sm={12} className="add-col-item ">
            <div
              className="d-flex add-buttons ms-4"
              style={{
                borderRadius: "12px",
                width: "196px",
                height: "51px",
                fontSize: "16px",
                gap: "14px",
              }}
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              onClick={() => {
                history.push("/add-workflow-automation");
              }}
            >
              <img
                src={hover ? AddIcon : formBuilder}
                alt="Add Icon"
                style={{ minWidth: "20px" }}
              />
              {/* &nbsp;&nbsp;Add New */}
              &nbsp;&nbsp;{t("Add new")}
            </div>
          </Col>
        </Row>
      </div>

      {/* Workflow list section  */}
      <div className="p-5">
        <WorkflowList />
      </div>
    </>
  );
};

export default WorkflowAutomationDashboard;
